import { lazy } from 'react';
import { Outlet, RouteObject } from 'react-router-dom';
import Loader from 'router/Loader';

const CustomersPage = Loader(
  lazy(() => import('content/pages/Private/Customers')),
);

const customersRouter: RouteObject[] = [
  {
    path: 'customers',
    element: <Outlet />,
    children: [
      {
        path: '',
        element: <CustomersPage />,
      },
    ],
  },
];

export default customersRouter;
